import React from 'react';
import propTypes from 'prop-types';

import Spinner from '~/Components/Global/Loading/Spinner';

import './WaterTracking.scss';
import HabitIcon from '../Assets/Svgs/HabitIcon';

const WaterActive = require('./WaterActiveUpdated.png');
const WaterInactive = require('./WaterInactive.png');

const WaterTracking = ({ water, updateWater, day, isFetching, setTracker }) => (
  <div className="water-tracking">
    <div className="water-tracking-title">
      <h6>WATER {isFetching && <Spinner />}</h6>
      <span className="toggle-tracker" onClick={() => setTracker('habit')}>
        <HabitIcon />
      </span>
    </div>
    {[...Array(8)].map((index, key) => {
      const drank = water && key + 1 <= water.drank;
      return (
        <div
          onClick={() => updateWater(!drank, day, water ? water.id : false)}
          key={key}
          className="water-cup"
        >
          <img className="water-filled" src={drank ? WaterActive : WaterInactive} />
        </div>
      );
    })}
  </div>
);

WaterTracking.propTypes = {
  water: propTypes.oneOfType([propTypes.object, propTypes.bool]),
  updateWater: propTypes.func,
  day: propTypes.string,
  isFetching: propTypes.bool,
  setTracker: propTypes.func,
};

export default WaterTracking;
